import PropTypes from "prop-types";
import styled from "styled-components";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "flex-start",
  width: "100%",
});

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 10px;
  gap: 10px;
`;

function RankingDesktop({ app, config }) {

  return (
    <div className="app Ranking">

      <div className="appContent">

        <LayoutCardsWrapper>

          <LayoutCardWrapper>

            <div className="row-controllers tutorial-ninth-step">

              <Card
                app={app}
                style={{ width: "100%", height: "100%" }}
                exportContainer
                exportTable
                exportTableId="QmAPSJp"
              >
                <NativeObject
                  app={app}
                  key={"AdDNd"}
                  reference={{ id: "AdDNd" }}
                  style={{
                    width: "100%",
                    height: "20%"
                  }}
                />
                <NativeObject
                  app={app}
                  key={"QmAPSJp"}
                  reference={{ id: "QmAPSJp" }}
                  type={"table"}
                />
              </Card>

              <Card
                app={app}
                style={{ width: "100%", height: "100%" }}
                exportContainer
                exportTable
                exportTableId="uBapw"
              >
                <NativeObject
                  app={app}
                  key="eMXCW"
                  reference={{ id: "eMXCW" }}
                  style={{
                    width: "100%",
                    height: "20%"
                  }}
                />
                <NativeObject
                  app={app}
                  key="uBapw"
                  reference={{ id: "uBapw" }}
                />
              </Card>

            </div>

            <Card
              app={app}
              style={{
                width: "100%",
                height: "100%"
              }}
              exportContainer
              exportTable
              exportTableId="DxsjPS"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  height: "20%",
                  width: "100%",
                  paddingBottom: "20px"
                }}
              >
                <NativeObject
                  app={app}
                  key="PcJe"
                  reference={{ id: "PcJe" }}
                  style={{
                    width: "50%",
                    border: "none"
                  }}
                />
                <NativeObject
                  app={app}
                  key="DgDjud"
                  reference={{ id: "DgDjud" }}
                  style={{
                    width: "50%"
                  }}
                />
              </div>
              <NativeObject
                app={app}
                key="DxsjPS"
                reference={{ id: "DxsjPS" }}
              />
            </Card>

          </LayoutCardWrapper>

        </LayoutCardsWrapper>

      </div >

    </div >
  );
}

RankingDesktop.defaultProps = {
  app: null,
  config: {},
};

RankingDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default RankingDesktop;